import type {
  AnalyticsChart,
  BuildChartContext,
  ChartDefinition,
  ChartResult,
} from '../catalog/types';
import { ChartResultStatus } from '../catalog/types';
import { buildChartData } from './buildChartData';
import { buildChartViewModel } from '../viewModel/buildChartViewModel';
import { EMPTY_CHART_VIEW_MODEL } from '../viewModel/emptyChartViewModel';

function toAnalyticsChart(
  definition: ChartDefinition,
  result: ChartResult,
  viewModel: AnalyticsChart['viewModel']
): AnalyticsChart {
  return {
    id: definition.id,
    section: definition.section,
    status: result.status,
    viewModel,
    error: result.error,
    filters: result.filters,
    dataGeneratedAt: result.dataGeneratedAt,
  };
}

export function buildAnalyticsChart(
  definition: ChartDefinition,
  result: ChartResult,
  ctx: BuildChartContext
): AnalyticsChart {
  const terminalStatuses: ChartResultStatus[] = [
    ChartResultStatus.idle,
    ChartResultStatus.loading,
    ChartResultStatus.error,
  ];

  if (terminalStatuses.includes(result.status)) {
    return toAnalyticsChart(definition, result, EMPTY_CHART_VIEW_MODEL);
  }

  const data = buildChartData(definition, result, ctx);
  const viewModel = buildChartViewModel(definition, data, ctx);
  return toAnalyticsChart(definition, result, viewModel);
}
